<template>
    <comCartView v-if="mobile==false" />
    <comCartViewMob v-if="mobile==true" />
</template>

<script>
  import comCartView from '../components/comCartView.vue'
  import comCartViewMob from '../components/comCartViewMob.vue'

  export default {
    data () {
      return {
        mobile: false,
      }
    },
    components: { comCartView, comCartViewMob },
    created() {
      this.mobile = this.$vuetify.display.mobile
    },
}
</script>